import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Hero from '../components/Hero';
import ServiceSection from '../components/ServiceSection';
import Contact from '../components/Contact';
import Logo from '../components/Logo';
import YogaSymbol from '../components/YogaSymbol';
import YantraBackground from '../components/YantraBackground';
import SoundNotification from '../components/SoundNotification';
import AnimatedBackground from '../components/AnimatedBackground';
import LiveStreamingBanner from '../components/LiveStreamingBanner';
import BackgroundCarousel from '../components/BackgroundCarousel';
import DailySpiritualInfoBanner from '../components/DailySpiritualInfoBanner';
import './Home.css';

const Home = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [showSoundNotification, setShowSoundNotification] = useState(false);

  useEffect(() => {
    document.body.classList.add('home-theme');
    return () => {
      document.body.classList.remove('home-theme');
    };
  }, []);

  const handleServiceClick = (service) => {
    if (service === 'online-pooja') {
      navigate('/online-pooja');
      // Scroll to top of the page after navigation
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else if (service === 'live-darshan') {
      navigate('/live-darshan');
      // Scroll to top of the page after navigation
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else if (service === 'bhakti-store') {
      navigate('/bhakti-store');
      // Scroll to top of the page after navigation
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else if (service === 'bhakti-yoga') {
      navigate('/bhakti-yoga');
      // Scroll to top of the page after navigation
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else if (service === 'bhakti-samadhan') {
      navigate('/bhakti-samadhan');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else if (service === 'bhakti-jaapa') {
      navigate('/bhakti-jaapa');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else if (service === 'bhakti-bal-chitra-katha') {
      navigate('/bhakti-bal-chitra-katha');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      // Scroll to section on same page
      const element = document.getElementById(service);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };


  const handleNotificationHide = () => {
    setShowSoundNotification(false);
  };

  return (
    <div className="home">
      {/* <AnimatedBackground />showing_Up
      showing_Up
       */}
      <BackgroundCarousel />
      <DailySpiritualInfoBanner />
      <Hero onServiceClick={handleServiceClick} />
      {/* <LiveStreamingBanner onServiceClick={handleServiceClick} /> */}
      <ServiceSection
        id="bhakti-samadhan"
        title={t('home.sections.bhaktiSamadhan.title')}
        subtitle={t('home.sections.bhaktiSamadhan.subtitle')}
        icon="fas fa-om"
        description={t('home.sections.bhaktiSamadhan.description')}
        features={t('home.sections.bhaktiSamadhan.features')}
      buttonText={t('home.sections.bhaktiSamadhan.buttonText')}
      onButtonClick={() => navigate('/bhakti-samadhan')}
      imageUrl="/images/pages/home/carosel/bs.jpg"
      reverse={true}
    />
      <ServiceSection
        id="online-pooja"
        title={t('home.sections.onlinePooja.title')}
        subtitle={t('home.sections.onlinePooja.subtitle')}
        icon="fas fa-hands-praying"
        description={t('home.sections.onlinePooja.description')}
        features={t('home.sections.onlinePooja.features')}
        buttonText={t('home.sections.onlinePooja.buttonText')}
        onButtonClick={() => navigate('/online-pooja')}
        imageUrl="/images/pages/home/carosel/op.jpg"
      />
      <ServiceSection
        id="live-darshan"
        title={t('home.sections.bhaktiDarshan.title')}
        subtitle={t('home.sections.bhaktiDarshan.subtitle')}
        icon="fas fa-video"
        description={t('home.sections.bhaktiDarshan.description')}
        features={t('home.sections.bhaktiDarshan.features')}
        buttonText={t('home.sections.bhaktiDarshan.buttonText')}
        onButtonClick={() => handleServiceClick('live-darshan')}
        secondaryButtonText={t('home.sections.bhaktiDarshan.secondaryButtonText')}
        onSecondaryButtonClick={() => handleServiceClick('bhakti-bal-chitra-katha')}
        imageUrl="/images/pages/home/carosel/bd.jpg"
        imageIcon="fas fa-video"
        imageText={t('home.hero.liveDarshan')}
        reverse={true}
      />
      <ServiceSection
        id="bhakti-store"
        title={t('home.sections.bhaktiStore.title')}
        subtitle={t('home.sections.bhaktiStore.subtitle')}
        icon="fas fa-store"
        description={t('home.sections.bhaktiStore.description')}
        features={t('home.sections.bhaktiStore.features')}
        buttonText={t('home.sections.bhaktiStore.buttonText')}
        onButtonClick={() => navigate('/bhakti-store')}
        imageUrl="/images/pages/home/carosel/bstore.jpg"
        reverse={true}
      />
      <ServiceSection
        id="bhakti-yoga"
        title={t('home.sections.bhaktiYoga.title')}
        subtitle={t('home.sections.bhaktiYoga.subtitle')}
        icon="fas fa-spa"
        description={t('home.sections.bhaktiYoga.description')}
        features={t('home.sections.bhaktiYoga.features')}
        buttonText={t('home.sections.bhaktiYoga.buttonText')}
        onButtonClick={() => handleServiceClick('bhakti-yoga')}
        imageUrl="/images/pages/home/carosel/by.jpg"
      />
      <ServiceSection
        id="bhakti-jaapa"
        title={t('home.sections.bhaktiJaapa.title')}
        subtitle={t('home.sections.bhaktiJaapa.subtitle')}
        icon="fas fa-book-open"
        description={t('home.sections.bhaktiJaapa.description')}
        features={t('home.sections.bhaktiJaapa.features')}
      buttonText={t('home.sections.bhaktiJaapa.buttonText')}
      onButtonClick={() => navigate('/bhakti-jaapa')}
      imageUrl="/images/pages/home/carosel/bj.jpg"
    />
      <ServiceSection
        id="services"
        title={t('home.sections.upcoming.title')}
        subtitle={t('home.sections.upcoming.subtitle')}
        // icon="fas fa-heart"
        // description="We offer a complete range of spiritual services to support your journey of devotion and self-discovery. From individual counseling to group sessions, we provide guidance for every aspect of your spiritual growth."
        features={t('home.sections.upcoming.features')}
        imageUrl="https://plus.unsplash.com/premium_photo-1732489895154-3772980b2a43?auto=format&fit=crop&w=1100&q=72"

        reverse={true}
      />
      <Contact />
    </div>
  );
};

export default Home;
